import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {getCartItemUnit, getFeatureUnit} from "../../../misc/helpers";

const LookFeatureQuantityText = (props) => {

  const {cartItem, intl, fabricatorData} = props;

  const featureUnit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity);
  const cartItemUnit = getCartItemUnit(cartItem, intl);
  return cartItemUnit || featureUnit
};

LookFeatureQuantityText.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface)
}

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData,
  }
};
export default injectIntl(
  connect(mapStateToProps)(LookFeatureQuantityText)
)
